// @ts-nocheck
import { Box } from '@mui/material';
import { formatCurrency } from '../../../../utils/currencyHelper';
import * as PropTypes from 'prop-types';
import './PaymentSummaryItem.css';

/**
 * Functional React component for rendering a custom payment summary item.
 *
 * @namespace Components
 *
 * @param {Object} props - The component's properties
 * @param {Object} [props.data] - The data for payment summary item.
 * @param {string} [props.id] - The ID for the payment summary item.
 * @param {...any} props.rest - Additional props to be spread on the parent element.
 *
 * @returns {JSX.Element} React element representing the payment summary item component.
 */

const PaymentSummaryItem = ({ data, id, ...rest }) => {
  const {
    title,
    amount,
    key,
    currencyConfig,
    isMutedItem = false,
    isAddOn = false
  } = data;
  const isTripPlan = key?.indexOf('tripplan') !== -1;
  // Add-ons should display with the same styling as trip plans
  const isPlanOrAddOn = isTripPlan || isAddOn;

  return (
    <Box
      className='payment-summary__item'
      data-testid='payment-summary-item'
      id={id}
      {...rest}
    >
      <div className='payment-summary__item-column'>
        <span
          className={`${isPlanOrAddOn ? 'payment-summary__item-column__italic-sm-text' : isMutedItem ? 'payment-summary__item--muted' : 'text-sm-bold payment-summary__item-column__title'}`}
        >
          {title}
        </span>
      </div>
      <div
        className={`payment-summary__item-column text-right ${isPlanOrAddOn ? 'payment-summary__item--muted-plan-price' : ''}`}
      >
        <span
          className={`${isPlanOrAddOn ? 'text-sm-medium ' : isMutedItem ? 'text-sm-medium  ' : 'text-sm-bold'}`}
        >
          {formatCurrency(amount, currencyConfig)}
        </span>
      </div>
    </Box>
  );
};

PaymentSummaryItem.propTypes = {
  data: PropTypes.shape({
    amount: PropTypes.number,
    currencyConfig: PropTypes.object,
    title: PropTypes.string,
    customTitleClass: PropTypes.string,
    key: PropTypes.string,
    isMutedItem: PropTypes.bool,
    isAddOn: PropTypes.bool
  }),
  id: PropTypes.string.isRequired
};

export default PaymentSummaryItem;
